<template>
  <div class="c-content-blue-box">
    <sc-image v-if="fields && fields.icon" :media="fields.icon" class="icon" />
    <sc-rich-text v-if="fields && fields.content" :field="fields.content" />
  </div>
</template>

<script>
import { Image, RichText } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Content-Blue-Box',
  components: {
    ScImage: Image,
    ScRichText: RichText
  },
  props: {
    fields: {
      type: Object
    }
  }
};
</script>
<style lang="scss" scoped>
.c-content-blue-box {
  padding: 3rem 2rem 1rem 2rem;
  background: linear-gradient(
    169deg,
    rgba(0, 0, 0, 1) 0%,
    rgba(0, 59, 92, 1) 20%,
    rgba(0, 134, 191, 1) 100%
  );
  border-radius: 5px;

  @include desktop-up {
    display: flex;
    padding: 3rem 5rem 1rem 5rem;
  }

  .icon {
    float: left;
    max-width: 6rem;
    margin-right: 3rem;
    margin-bottom: 0;

    @include desktop-up {
      float: none;
      height: fit-content;
    }
  }

  &:deep() {
    h1,
    h2,
    h3,
    h4,
    a,
    p,
    span,
    div,
    ul li {
      color: $white;
    }

    h1,
    h2 {
      background: none;
      -webkit-background-clip: initial;
      background-clip: initial;
      -webkit-text-fill-color: initial;
    }

    h1,
    h2,
    h3,
    h4 {
      clear: none;
    }

    .c-cta--primary {
      font-weight: 700;
      margin-top: 1.5rem;
      color: $dark-blue;
    }

    .c-cta--secondary {
      color: $white;
      border-color: $white;

      &:hover {
        color: $white;
      }

      &:after {
        background: url(~@/assets/images/icon-arrow-right-white-mobile.svg) no-repeat;
      }
    }

    .c-cta--tertiary {
      font-weight: 500;

      &:hover {
        color: $white;
      }

      &:after {
        background: url(~@/assets/images/icon-arrow-right-white-mobile.svg) no-repeat;
      }
    }

    .hide-desktop-below {
      display: none;

      @include desktop-up {
        display: block;
      }
    }
  }
}
</style>
